import { openDB } from "idb";

const DB_NAME = "players-db";
const DB_VERSION = 2;

let dbPromise;

/**
 * Ouvre la base de données IndexedDB avec la bonne version
 * La connexion est mémorisée : les centaines d'accès aux notes des joueurs
 * partagent une seule et même connexion
 * @returns {Promise<IDBDatabase>}
 */
const getPlayersDb = async () => {
  if (! dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade (db) {
        if (! db.objectStoreNames.contains("playerInfos")) {
          db.createObjectStore("playerInfos");
        }
        if (! db.objectStoreNames.contains("playersPool")) {
          db.createObjectStore("playersPool");
        }
      },
    });
  }
  return dbPromise;
};

export { getPlayersDb };